import css from "../../css/find-agent/agents.module.css";

import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import Avatar from "../agents/Avatar";
import phoneLinkFormatter from "../../helper/phoneLinkFormatter";
import { THUMB_150_150 } from "../../service/photo";

import SealIcon from "mdi-react/SealIcon";
import BullhornOutlineIcon from "mdi-react/BullhornOutlineIcon";
import EnvelopeIcon from "../../static/icons/envelope2.svg";
import PhoneIcon from "../../static/icons/phone.svg";
import useMobile from "../../hooks/useMobile";

const Agent = (props) => {
    const { agent } = props;
    const isMobile = useMobile();

    const { is_featured } = agent;

    return (
        <div className={css.agent}>
            <div className={css.photo}>
                {is_featured && <SealIcon className={css.featuredIcon} />}
                <Link
                    href={`/agent?agent=${agent.url}`}
                    as={`/real_estate_agent/${agent.url}`}
                >
                    <Avatar photo={agent.photo} size={THUMB_150_150} />
                </Link>
                <Link
                    href={`/agent?agent=${agent.url}`}
                    as={`/real_estate_agent/${agent.url}`}
                    className={css.button}
                >
                    View Profile
                </Link>
            </div>
            <div className={css.profile}>
                <div className={css.name}>{agent.full_name}</div>
                {is_featured && (
                    <div className={css.featuredBadge}>
                        <BullhornOutlineIcon /> <span>Featured Profile</span>
                    </div>
                )}
                {agent.office_name && (
                    <div className={css.company}>{agent.office_name}</div>
                )}
                <div className={css.email}>
                    <EnvelopeIcon /> {agent.email}
                </div>
                {agent.phone_primary && (
                    <div className={css.phone}>
                        {isMobile && (
                            <a href={phoneLinkFormatter(agent.phone_primary)}>
                                <PhoneIcon /> {agent.phone_primary}
                            </a>
                        )}
                        {!isMobile && (
                            <>
                                <PhoneIcon /> {agent.phone_primary}
                            </>
                        )}
                    </div>
                )}
                <div className={css.rating} />
            </div>
        </div>
    );
};

Agent.propTypes = {
    agent: PropTypes.object.isRequired,
};

export default Agent;
